import TagManager from "react-gtm-module";

function SchoolSearchMajor({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "school_search_major",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default SchoolSearchMajor;
